import { isFieldForCategory, isFieldForListingType } from './fieldHelpers';
import {
  SCHEMA_TYPE_ENUM,
  SCHEMA_TYPE_LONG,
  SCHEMA_TYPE_MULTI_ENUM,
  SCHEMA_TYPE_TEXT,
} from './types';

export const reduceAttributes = (publicData, currentCategories) => (reduced, fieldConfig) => {
  const { key, enumOptions, schemaType, showConfig } = fieldConfig;
  const listingType = publicData.listingType;
  // Check if the field is for the current listing type and category (limitations)
  const isTargetListingType = isFieldForListingType(listingType, fieldConfig);
  const isTargetCategory = isFieldForCategory(currentCategories, fieldConfig);

  const value = publicData[key];
  const label = showConfig.label;

  if (!value || !isTargetListingType || !isTargetCategory) {
    return reduced;
  }

  let displayValue;

  switch (schemaType) {
    case SCHEMA_TYPE_TEXT:
    case SCHEMA_TYPE_LONG:
      displayValue = value;
      break;
    case SCHEMA_TYPE_ENUM:
      displayValue = enumOptions?.find(({ option }) => option === value)?.label;
      break;
    case SCHEMA_TYPE_MULTI_ENUM:
      displayValue = enumOptions
        ?.filter(({ option }) => value.indexOf(option) !== -1)
        .map(({ label }) => label)
        .join(', ');
      break;
    default:
      break;
  }

  if (!displayValue) {
    return reduced;
  }

  return { ...reduced, [key]: { key, value, label, displayValue } };
};
